import * as bootstrap from 'bootstrap';
import NiceSelect from "nice-select2";
import mask from './src/formMasks.js';
import Swal from 'sweetalert2';

window.bootstrap = bootstrap;

/**
 * -----------------------------------------------------------------------------
 * Bootstrap Tooltips
 * -----------------------------------------------------------------------------
 *
 * Inicializa todos os tooltips do Bootstrap 5 presentes na página.
 */
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
tooltipTriggerList.forEach((tooltipTriggerEl) => {
    tooltipTriggerEl._tooltipInstance = new bootstrap.Tooltip(tooltipTriggerEl);
});

/**
 * -----------------------------------------------------------------------------
 * Links externos
 * -----------------------------------------------------------------------------
 *
 * Lembre-se de inserir o ícone em CSS
 */
const external_links = document.querySelectorAll('header a[href*="//"], main a[href*="//"], footer a[href*="//"]');
if(external_links) {
    external_links.forEach((el) => {
        let site = new RegExp('/' + window.location.host);

        if(1 == 0
            || site.test(el.getAttribute('href'))
            || el.classList.contains('skip-external')
        ) { return true; }

        // Adicionar atributos "rel"
        el.setAttribute('rel', 'external noopener noreferrer');
        el.setAttribute('title', 'Site externo');
    })
}

/**
 * -----------------------------------------------------------------------------
 * Links com target _blank
 * -----------------------------------------------------------------------------
 *
 * Adicionar atributos de segurança para links que abrem em nova aba
 */
const blank_links = document.querySelectorAll('a[target="_blank"]');
if(blank_links) {
    blank_links.forEach((el) => {
        el.setAttribute('rel', 'noopener noreferrer');
    });
}

/**
 * -----------------------------------------------------------------------------
 * Resultados rápidos da pesquisa
 * -----------------------------------------------------------------------------
 */
const inputSearch = document.getElementById('search');
if(inputSearch) {
inputSearch.addEventListener('keyup', () => {
    let xhr = new XMLHttpRequest();
    let searchString = inputSearch.value;
    let container = document.getElementById('searchResult');
    let params = new URLSearchParams({
        search: searchString,
        per_page: 5,
        subtype: [
            'page',
            'post',
            'cpt-partner',
            'cpt-document',
        ],
        orderby: 'post_date',
        order: 'DESC',
    });
    let url = '/wp-json/gn/v1/quick-search?' + params.toString();

    if(searchString.length >= 3) {
        xhr.open("GET", url, true);

        xhr.onreadystatechange = function()
        {
            if(this.readyState == 4 && this.status == 200) {
                let data = JSON.parse(this.responseText);

                if(data) {
                    let html = '<table class="table form-table">';

                    data.forEach((item, i) => {
                        let ptype = window.WP_PostTypeLabels[item.subtype] || item.subtype;

                        html+= '<tr>';
                            html+= '<th>'+ ptype +' <i class="fas fa-caret-right"></i> </th>' + "\n";
                            html+= '<td><a class="form-link" href="'+ item.url +'">' + item.title + '</a></td>' + "\n";
                        html+= '</tr>' + "\n";
                    });
                    html+= '<table>';

                    container.innerHTML = html;
                }
            }
        }

        // Sending our request
        xhr.send();
    }
});
}

/**
 * -------------------------------------------------------------------------------
 * Filtros de documentos
 * -------------------------------------------------------------------------------
 */
var nice_select = [];
const arr_select_document = document.querySelectorAll('.form-cpt-document select');
if(arr_select_document) {
arr_select_document.forEach((input, i) =>
{
    let key = input.getAttribute('name');
    let default_label = input.getAttribute('data-default-label');

    nice_select[key] = new NiceSelect(input, {
        searchable: false,
        placeholder: default_label
    });

    input.addEventListener('change', updateOption);

    // Atualizar também no carregamento da página
    updateOption({ currentTarget: input }, true);

    function updateOption(e, force = false)
    {
        let val = e.currentTarget.value;
        let ptype = e.currentTarget.getAttribute('data-type');
        let target = e.currentTarget.getAttribute('data-target');
        let select = document.getElementById(target);
        let arr_btn = document.querySelectorAll('.btn-filter');
        let default_label = select.getAttribute('data-default-label');

        // Liberar/bloqueaar o botão de submit
        if(val || select.value) {
            arr_btn.forEach(btn => btn.removeAttribute('disabled'));
        }

        else {
            arr_btn.forEach(btn => {
                let always = btn.getAttribute('data-always');

                if(always != 'true') {
                    btn.setAttribute('disabled', 'disabled');
                }
            });
        }

        if(!force && select.value) return;

        let params = new URLSearchParams({
            id: val,
            post_type: ptype,
        });

        let url = '/wp-json/gn/v1/document-filter?' + params.toString();

        // Iniciar requisição
        let xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);

        // Definir o que acontece quando a requisição for concluída
        xhr.onreadystatechange = function()
        {
            if(this.readyState == 4 && this.status == 200) {
                let data = JSON.parse(this.responseText);
                let value = select.value;

                select.innerHTML = '<option value="">'+ default_label +'</option>';

                if(data) {
                data.forEach((item, i) => {
                    let option = document.createElement('option');
                    option.value = item.ID;
                    option.textContent = item.title;

                    if(item.ID == value) option.selected = true;

                    select.appendChild(option);
                });
                }

                nice_select[select.getAttribute('name')].update();
            }
        }

        // Enviar requisição
        xhr.send();
    }
});
}

const btn_clean_filter = document.getElementById('filterClean');
if(btn_clean_filter) {
btn_clean_filter.addEventListener('click', (e) => {
    let target = e.currentTarget.getAttribute('data-target');

    console.log(target);

    window.location.href = target;
});
}

/**
 * -------------------------------------------------------------------------------
 * Filtro de categoria de documento (AJAX)
 * -------------------------------------------------------------------------------
 */
const categoryFilter = document.getElementById('documentCategoryFilter');
if(categoryFilter) {
const resultsContainer = document.getElementById(categoryFilter.getAttribute('data-target'));

categoryFilter.addEventListener('click', (e) => {
    let btn = e.target.closest('.btn-filter-category');
    if(!btn) return;

    let category = btn.getAttribute('data-category');
    let partnerInput = document.getElementById('filter-partner');
    let productInput = document.getElementById('filter-product');

    let params = new URLSearchParams({
        filter_partner: partnerInput ? partnerInput.value : '',
        filter_product: productInput ? productInput.value : '',
        filter_category: category,
    });

    let xhr = new XMLHttpRequest();
    xhr.open('GET', '/wp-json/gn/v1/document-listing?' + params.toString(), true);

    xhr.onreadystatechange = function()
    {
        if(this.readyState == 4 && this.status == 200) {
            let data = JSON.parse(this.responseText);

            if(resultsContainer) resultsContainer.innerHTML = data.html;

            categoryFilter.querySelectorAll('.btn-filter-category').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            let url = new URL(window.location.href);
            url.searchParams.set('filters', 'true');

            if (partnerInput?.value) url.searchParams.set('filter_partner', partnerInput.value);
            else url.searchParams.delete('filter_partner');

            if (productInput?.value) url.searchParams.set('filter_product', productInput.value);
            else url.searchParams.delete('filter_product');

            if (category) url.searchParams.set('filter_category', category);
            else url.searchParams.delete('filter_category');

            history.pushState({}, '', url);
        }
    }

    xhr.send();
});
}

const arr_select = document.querySelectorAll('select[multiple]');
if(arr_select) {
arr_select.forEach((input, i) =>
{
    new NiceSelect(input, {
        searchable: false,
        placeholder: ''
    });
});
}

// Limitar quantidade de caracteres nos campos de formulário
const input = document.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"]');
if(input) input.forEach((el) => {
    if(!el.hasAttribute('maxlength')) {
        el.setAttribute('maxlength', '150');
    }
});

const input_url = document.querySelectorAll('input[type="url"]');
if(input_url) input_url.forEach((el) => {
    if(!el.hasAttribute('maxlength')) {
        el.setAttribute('maxlength', '300');
    }
});

const textarea = document.querySelectorAll('textarea');
if(textarea) textarea.forEach((el) => {
    if(!el.hasAttribute('maxlength')) {
        el.setAttribute('maxlength', '400');
    }
});

document.addEventListener('input', (e) => {
    const input = e.target;

    if (!input.classList.contains('mask')) {
        return;
    }

    // Somente letras
    if(input.classList.contains('mask-letter')) {
        input.value = mask.onlyLetters(input.value);
    }

    // Somente números
    if(input.classList.contains('mask-number')) {
        input.value = mask.onlyNumbers(input.value);
    }

    // Máscara de telefone
    if(input.classList.contains('mask-phone')) {
        input.value = mask.maskPhone(input.value);
    }

    // Máscara de CPF/CNPJ
    if(input.classList.contains('mask-doc')) {
        input.value = mask.maskDoc(input.value);
    }

    // Máscara de CPF
    if(input.classList.contains('mask-cpf')) {
        input.value = mask.maskCPF(input.value);
    }

    // Máscara de CNPJ
    if(input.classList.contains('mask-cnpj')) {
        input.value = mask.maskCNPJ(input.value);
    }

    // Máscara de CEP
    if(input.classList.contains('mask-cep')) {
        input.value = mask.maskCEP(input.value);
    }

    // Máscara de hora
    if(input.classList.contains('mask-hour')) {
        input.value = mask.maskHour(input.value);
    }
});

const cookieButton = document.querySelector('[data-trigger="cookie-accept"]');
if(cookieButton) {
    cookieButton.addEventListener('click', () => {
        document.cookie = "accepted_cookies=yes";
        location.reload();
    });
}

document.addEventListener('wpcf7mailfailed', function(e)
{
    const resp = document.querySelector('.wpcf7 .wpcf7-response-output');

    if (resp) resp.style.display = 'none';

    setTimeout(() => {
        let title = 'Erro ao enviar o formulário';
        let message = resp.innerText;

        sweetAlert(title, message, 'error');
    }, 500);

}, false);

document.addEventListener('wpcf7invalid', function(e)
{
    const resp = document.querySelector('.wpcf7 .wpcf7-response-output');

    if (resp) resp.style.display = 'none';

    setTimeout(() => {
        let title = 'Verifique os campos do formulário';
        let message = resp.innerText;

        sweetAlert(title, message, 'warning');
    }, 500);

}, false);

document.addEventListener('wpcf7mailsent', function(e)
{
    const resp = document.querySelector('.wpcf7 .wpcf7-response-output');

    if (resp) resp.style.display = 'none';

    setTimeout(() => {
        let title = 'Sucesso!';
        let message = resp.innerText;

        sweetAlert(title, message, 'success');
    }, 500);

}, false);

function sweetAlert(title, message, type)
{
    Swal.fire({
        title: title,
        text: message,
        icon: type,
        confirmButtonText: 'Fechar',
        customClass: {
            confirmButton: "btn btn-primary",
        },
    });
}

const urlParams = new URLSearchParams(window.location.search);
const success = urlParams.get('success');
const message = urlParams.get('message');

if(success && message) {
    sweetAlert('Sucesso!', decodeURIComponent(message), 'success');
}
